import { createContext, useContext } from "react";

type ExpandableContextType = { isExpanded: boolean } | null;

const ExpandableContext = createContext<ExpandableContextType>(null);

export const ExpandableProvider = ExpandableContext.Provider;

export const useExpandable = () => useContext(ExpandableContext);
